<template>
  <form v-if="training" @submit.prevent>
    <b-field
      :message="errors.name"
      :type="getErrorStatus('name')"
      :label="labels.name"
      class="form-field">
      <input :id="`name-${index}`"
             :value="training.name"
             :class="getErrorStatus('name')"
             class="input input-normal paragraph-m"
             type="text"
             @blur="validateField('name')"
             @input="updateStateOnInput('name', $event)"/>
    </b-field>
    <b-field
      :label="`${labels.year} ${labels.optional}`"
      class="form-field">
      <year-month-select
        :id="`startDate-${index}`"
        :yearError="errors.year"
        :selectedYear="training.year"
        :showMonth="false"
        name="startDate"
        @blur-year="validateField('year')"
        @select-year="changeState('year', $event)"
      >
      </year-month-select>
    </b-field>
    <b-field
      :message="errors.notes"
      :type="getErrorStatus('notes')"
      :label="`${labels.notes} ${labels.optional}`"
      class="form-field">
      <b-input
        :id="`notes-${index}`"
        :value="training.notes"
        class="paragraph-m"
        type="textarea"
        @blur="validateField('notes')"
        @input.native="updateStateOnInput('notes', $event)">
      </b-input>
    </b-field>
  </form>
</template>

<script>

import 'top20common/distribution/icons/buildings';

import InputField from 'top20common/components/form/InputField';
import {mapGetters} from 'vuex';

import YearMonthSelect from '@/common/components/inputs/YearMonthSelect';
import validation from '@/services/validation';

export default {
  props: {
    training: Object,
    index: Number
  },
  data() {
    return {
      validation: {
        name: [validation.required, validation.maxLength(255)],
        year: [],
        notes: []
      }
    };
  },
  computed: {
    ...mapGetters(['trainingsErrorsListState']),
    labels() {
      return {
        name: this.$gettext('Training or certificate name'),
        year: this.$gettext('Year'),
        notes: this.$gettext('Description'),
        optional: this.$gettext('(optional)')
      };
    },
    errors() {
      return this.trainingsErrorsListState[this.index];
    }
  },
  methods: {
    getErrorStatus(field) {
      return this.errors[field] ? 'is-danger' : '';
    },
    updateStateOnInput(key, event) {
      this.changeState(key, event.target.value);
    },
    changeState(fieldName, value) {
      this.$store.commit('mutateTrainingsByIndexState', {index: this.index, changedField: {[fieldName]: value}});
      this.$store.commit('mutateTrainingsErrorItem', {index: this.index, changedField: {[fieldName]: ''}});
      this.$emit('field-change');
    },
    validate() {
      for (let field in this.validation) {
        this.validateField(field);
      }
    },
    validateField(field) {
      let message = validation.validateField(this.validation[field], this.training[field]);
      this.$store.commit('mutateTrainingsErrorItem', {index: this.index, changedField: {[field]: message}});
    }
  },
  components: {
    YearMonthSelect,
    InputField
  }
};
</script>
<style lang="scss" scoped>
.form-field {
  margin-bottom: 20px;
}
.form-label {
  margin-bottom: 5px;
  display: block;
}
/deep/ .svg-icon {
  stroke: var(--gray);
}
</style>
